import { apolloClient } from "@/plugins/vue-apollo.js";

const updateCustomer = async (_variables) => {
    // , limit, skip
  let responseFromApi;
  let variables = _variables;
  // debugger
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/user/api/mutations/customer/update_customer.graphql"),
      variables: variables,
      
    //   update: (store, { data }) => {
    //     const query = {
    //       query: require("@/user/api/queries/customer/customer_query.graphql"),
    //       variables: {
    //         input: {
    //           limit: 10,
    //           skip: 0
    //         },
    //         filter: {
    //           searchKey: ''
    //         }
    //       },
    //     };
    //     let allCustomers = store.readQuery(query);
    //     // debugger
    //     const findIndex = allCustomers.getCustomers.custoemrs.findIndex(
    //       (item) => item._id === data.updateCustomer._id
    //     );
    //     findIndex !== -1 &&
    //       allCustomers.getCustomers.custoemrs.splice(
    //         findIndex,
    //         1,
    //         data.updateCustomer
    //       );
    //     store.writeQuery({
    //       ...query,
    //       data: allCustomers,
    //     });
    //   },
    })
    .catch((error) => {
      return error;
    });
  return responseFromApi;
};
export { updateCustomer };
